import React from 'react';

import axios from 'axios';

import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';


//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Icon} from '../inspinia'
import Pagination from "react-js-pagination";
import CircularProgress from '@material-ui/core/CircularProgress';
import SelectMultiSelect from 'react-select';


class Empresas extends React.PureComponent
{
    constructor(props)
    {
        super(props);     
        
        this.state = {
            loading: false, filter: "", page: 0,
            form: this.formInitialState(),
            list: 
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, content: undefined
            },

            emailUsuario: this.props.auth.user.email,

            comboProduto: {
                results: undefined
            },

            optionsGet : { method: 'GET' , headers: { 'Content-Type': 'application/json' } },
            
        }

        this.handleBuscarInput      = this.handleBuscarInput.bind(this); 
        this.handlePageChange       = this.handlePageChange.bind(this);
        this.handleAdicionarEmpresa = this.handleAdicionarEmpresa.bind(this);
        this.handleChange           = this.handleChange.bind(this);
        this.handleLimparPesquisa   = this.handleLimparPesquisa.bind(this);
        this.handleMensagemSucesso = this.handleMensagemSucesso.bind(this);
        this.handleChangeSelectMulti = this.handleChangeSelectMulti.bind(this);
    }

    formInitialState () 
    {
        return {
            id: "",
            empresa: "",
            produtos: null
        }
    }


    componentDidMount()
    {
        this.LoadListaProdutos();
        this.LoadListaEmpresa();
    }

    handleMensagemSucesso(nomeEmpresa)
    {
        c.TOASTER_SUCCESS(`Empresa ${nomeEmpresa} cadastrada com sucesso!`);  
    }

    handleMensagemEdicao(nomeEmpresa)
    {
        c.TOASTER_SUCCESS(`Empresa ${nomeEmpresa} editada com sucesso!`);  
    }

    handleLimparPesquisa(edicao)
    {        

        let nomeEmpresa = this.state.form.empresa;

        this.state.list = [];
        this.state.form.id = '';
        this.state.form.empresa = '';
        this.state.form.produtos = null;
        this.LoadListaEmpresa(this.state.page);
        
        if(edicao) {
            this.handleMensagemEdicao(nomeEmpresa);

        } else {
            this.handleMensagemSucesso(nomeEmpresa);

        }
        

    }

    handleChange(e) {

        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });

    }

    onNomeEmpresaChange(empresaEdicao) {

        const form = this.state.form;

        this.setState({ form: { ...form, empresa: empresaEdicao.nome, id: empresaEdicao.id, produtos: empresaEdicao.comboProdutos } });

    }

    onLoadingChange(loading) {

        this.setState({...this.state, loading})

    }

    handleAdicionarEmpresa() {
        const form = this.state.form;

        if(this.state.form.empresa.length == 0){
            c.TOASTER_ERROR(`Favor preencher o nome da empresa!`);  
            return;
        }
        
        if(this.state.form.produtos === null || this.state.form.produtos.length == 0){
            c.TOASTER_ERROR(`Favor selecionar ao menos um produto!`);  
            return;
        }
        
        if(form.id === ''){
            this.SaveEmpresa();

        } else {
            this.EditarEmpresa(form.id);
        }
        
    }

    SaveEmpresa(e) {

        let self = this;
        let url = `${c.API_BASE_URL}/empresas`
        
        const options = {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({      
                nome: this.state.form.empresa,
                comboProdutos: this.state.form.produtos
            })
        };

        callApi(url, options, function(response)
        { 
            self.setState({ ...self.state, loading: false, page: 0 }, self.handleLimparPesquisa());      
        });
    }
    

    EditarEmpresa(idEmpresa) {

        let self = this;
        let url = `${c.API_BASE_URL}/empresas/${idEmpresa}`
        const options = {
            method: 'PUT' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({      
                nome: this.state.form.empresa,
                comboProdutos: this.state.form.produtos
            })
        };    

        callApi(url, options, function(response)
        { 
            self.setState({ ...self.state, loading: false, page: 0 }, self.handleLimparPesquisa(true));      
        });

    }

    handleBuscarInput(e)
    {
        this.setState({ ...this.state, filter: e.target.value });   
    }


    handlePageChange(pageNumber) 
    {

        this.state.page = pageNumber;
        this.LoadListaEmpresa(pageNumber);
    }

    handleChangeSelectMulti(selectedOption) {

        const form = this.state.form;

        this.setState({ form: { ...form, produtos: selectedOption } });

    }

    render()
    {


        return (                     
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Listas de Empresas</h3>
                            </Title>

                            <Content>
                                
                                <Row className="m-0 mb-3">
                                    <Column size="12" className="p-0 mx-auto container">

                                        <Row className="form-row">
                                            <div className="form-group col-md-5">   
                                                <input type="text" name="empresa" value={this.state.form.empresa} onChange={this.handleChange} className="form-control" placeholder="Nova empresa"/>                                                 
                                            </div>
                                            <div className="form-group col-md-4"> 
                                                <SelectMultiSelect 
                                                    value={this.state.form.produtos} 
                                                    onChange={this.handleChangeSelectMulti} 
                                                    options={this.state.comboProduto.results} 
                                                    isMulti='true' 
                                                    placeholder='Selecione um produto ou vários produtos'/>
                                            </div>
                                            <div className="form-group col-md-5">
                                                <Button onClick={this.handleAdicionarEmpresa} className="btn btn-primary">Incluir</Button>                                                   
                                            </div>  
                                            <div className="form-group col-md-2">
                                                {this.state.loading && (                    
                                                    <CircularProgress />                    
                                                )}
                                            </div>  
                                                                            
                                        </Row> 
                                        
                                    </Column>

                                    
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this.props.history} contexto={this}/>                                        
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>                     
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.size}
                                        totalItemsCount={this.state.list.totalElements}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>                
            </div>
        );
    }
 
    LoadListaEmpresa(pageNumber)
    {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;
        
        const url = `${c.API_BASE_URL}/empresas?page=${page}&size=${size}`;
        const options = self.state.optionsGet;
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, list: response});
        });
    }

    LoadListaProdutos() {
        self = this;

        const url = `${c.API_BASE_URL}/produto/combo`;
        const options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

        callApi(url, options, function (response) {
            self.setState({ ...self.state, comboProduto: response}); 
        });
    }
}

class Table extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            loading: false,    
        }

        this.editarClick   = this.editarClick.bind(this);
        this.excluirClick    = this.excluirClick.bind(this);
    }

    editarClick(id)
    {
        if (parseInt(id) === 0) return;        

        let empresas = this.props.data.content;
        let nomeEmpresa = '';

        nomeEmpresa = empresas.filter((empresa) => empresa.id === id);

        this.props.contexto.onNomeEmpresaChange(nomeEmpresa[0]);

    }


    excluirClick(id)
    {
        if (parseInt(id) === 0) return;

        this.LoadExcluir(id);        

    }

    statusEnvio(status){
        if (status == "Em Uso"){
            return( <span style={{color:"#EF7800"}}>Em Uso</span>)
        }
        else if (status == "Ativa"){
            return( <span style={{color:"#009966"}}>Ativa</span>)
        }
        else if (status == "Utilizada"){
            return( <span style={{color:"#BBBBBB"}}>Rejeitado</span>)
        }
    }

    LoadExcluir(id)
    {

        let self = this;
        let url = `${ c.API_BASE_URL }/empresas/${id}`
        
        const options =
        {
            method: 'DELETE'
            ,headers: { 'Content-Type': 'application/json' }
        };

        callApi(url, options, function(response)
        { 
            self.props.contexto.LoadListaEmpresa(0);

            self.props.contexto.onLoadingChange(false);

            c.TOASTER_SUCCESS("Empresa excluída com sucesso!"); 

        });

    }



    render()
    {    
        const data = this.props.data; 
        let html = "";

        if (data.content === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.content.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.content.length   > 0)
        {
            html = data.content.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.id}</td>
                    <td>{row.nome}</td>
                    <td>{row.produtos}</td>
                    <td className="text-center">
                        <a onClick={() => this.editarClick(row.id)}><Icon name="fa-pencil" className="mx-1 text-success" /></a>
                        <a onClick={() => this.excluirClick(row.id)}><Icon name="fa-times" className="mx-1 text-muted" /></a>
                    </td>
                </tr>           
            );
        }

        return(
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{backgroundColor: "#dbf1e9"}}>       
                        <th>#</th>
                        <th>Nome da empresa</th>
                        <th>Produtos</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Empresas));
